export interface Price extends PriceInfo {
  discountPercentage: number
  exchangeRateAppliedPrice: PriceInfo | null
}

export interface PriceInfo {
  currency: Currency
  originalAmount: number
  discountedAmount: number
}

export enum Currency {
  KRW = 'KRW',
  JPY = 'JPY',
  USD = 'USD',
  THB = 'THB',
}
